import VueRouter from 'vue-router'
import TVERendezvous from 'vue/components/tveRendezvous/TVERendezvous'
import {TVE_RENDEZVOUS_BASE_PATH} from "aa/vue/constants/aaRoutes";

function generateRoutes(store) {

    let pageAttrsNeedUpdate = false

    function getPageAttributes(routeTo) {
        if (pageAttrsNeedUpdate) {
            let tags = routeTo.name ? ['page_' + routeTo.name.toLowerCase()] : []

            return store.dispatch('pageAttributes/loadByTags', tags)
        }

        pageAttrsNeedUpdate = true
    }

    function routeEnter(to, next) {
        getPageAttributes(to)
        next()
    }

    // set replace true?
    function routeRedirect(next, path) {
        pageAttrsNeedUpdate = true
        next(path)
    }

    return [
        {
            path: '/:flow/',
            name: 'TVE_RENDEZVOUS',
            component: TVERendezvous,
            beforeEnter: (to, from, next) => {
                routeEnter(to, next);
            },
            meta: {
                hideSignInLink: true,
                hideSignUpLink: true,
            },
        },
    ];
}


export default function (store) {
    return new VueRouter({
        mode: 'history',
        base: TVE_RENDEZVOUS_BASE_PATH,
        routes: generateRoutes(store)
    })
}
